import { Anchor, Breadcrumbs as MantineBreadcrumbs } from '@mantine/core';
import { useMatches } from 'react-router-dom';

export const Breadcrumbs = () => {
  let matches = useMatches();

  let crumbs = matches
    // first get rid of any matches that don't have handle and crumb
    .filter((match) => Boolean((match.handle as any)?.crumb))
    // now map them into an array of elements, passing the loader
    // data to each one
    .map((match) => (match.handle as any).crumb(match));

  return crumbs.length ? (
    <MantineBreadcrumbs>
      {crumbs.map(({ title, link }, index) => (
        <Anchor key={index} href={link}>
          {title}
        </Anchor>
      ))}
    </MantineBreadcrumbs>
  ) : null;
};
